export default __webpack_public_path__ + "744236ff550913af143cde3516b8ae72.svg";